import React from 'react';

//styling

// constants
import {
  BACK, COST_OF_SALES_OPTIONS,
  INCOME_SOURCE_OPTIONS,
  INCOME_STATEMENT_PAGES
} from './constants';

import TopToolbar from '../../global/subcomponents/topToolbar/TopToolbar';

import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { Divider, Checkbox, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import SaveIcon from '@material-ui/icons/Save';
import { Chip, IconButton } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import MenuIcon from '@mui/icons-material/Menu';

class IncomeStatementSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      category: [],
      requiredList: ['name','category'],
      templates: this.props.templates || [],
      open: false,
      anchorEl: null,
      activeIndex: null,
      draggedIndex: null,
      draggedSection: null,
    };
  }

  componentDidMount() {
    if (this.props.templates && this.props.templates.length > 0) {
      this.setState({ templates: [...this.props.templates] });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.templates !== this.props.templates ||
      nextState.templates !== this.state.templates ||
      nextState.anchorEl !== this.state.anchorEl ||
      nextState.activeIndex !== this.state.activeIndex ||
      nextState.draggedIndex !== this.state.draggedIndex
    );
  }

  onDragStart = (index, sectionName) => {
    this.setState({ draggedIndex: index, draggedSection: sectionName });
  };

  onDragOver = (hoverIndex, sectionName) => {
    const { draggedIndex, draggedSection, templates } = this.state;

    // Only reorder within the same section
    if (draggedIndex === null || draggedSection !== sectionName) return;

    // Filter out the section templates based on sectionName
    const sectionTemplates = templates.filter(t => t.section === sectionName);

    // Map the section templates to their respective global indices
    const sectionIndices = sectionTemplates.map((t, index) => {
      const globalIndex = templates.findIndex(item => item === t);
      return { ...t, index: globalIndex };
    });

    // Get the global index for the dragged item and the hover item
    const dragGlobalIndex = sectionIndices[draggedIndex].index;
    const hoverGlobalIndex = sectionIndices[hoverIndex].index;

    // Only proceed if the hover index is different from the dragged index
    if (dragGlobalIndex === hoverGlobalIndex) return;

    const updatedTemplates = [...templates];

    // Remove the dragged item from its current position
    const [draggedItem] = updatedTemplates.splice(dragGlobalIndex, 1);

    // Insert the dragged item at the hover position
    updatedTemplates.splice(hoverGlobalIndex, 0, draggedItem);

    // Update state with the new templates order
    this.setState({
      templates: updatedTemplates,
      draggedIndex: hoverIndex,
    });
  };

  onDragEnd = () => {
    this.setState({ draggedIndex: null, draggedSection: null });
  };

  handleChange = (state) => {
    this.setState(state);
  };

  getSectionIndex = (templates, sectionName, currentIndex) => {
    let count = -1;
    for (let i = 0; i <= currentIndex; i++) {
      if (templates[i].section === sectionName) {
        count++;
      }
    }
    return count;
  };

  handleTemplateChange = (e, index, sectionName) => {
    const { name, value } = e.target;

    this.setState((prevState) => {
      const updatedTemplates = prevState.templates.map((template, i) => {
        if (template.section === sectionName && index === this.getSectionIndex(prevState.templates, sectionName, i)) {

          if (name === 'source') {
            return {
              ...template,
              source: value,
              category: []
            };
          }

          return {
            ...template,
            [name]: value,
          };
        }
        return template;
      });

      return { templates: updatedTemplates };
    });
  };


  removeTemplateRow = (index, sectionName) => {
    this.setState((prevState) => {
      const sectionTemplates = prevState.templates.filter(template => template.section === sectionName);

      const updatedTemplates = prevState.templates.filter((template, curIndex) => {
        if (template.section === sectionName) {
          const sectionIndex = sectionTemplates.findIndex(t => t === template);
          return sectionIndex !== index;
        }
        return true;
      });
      return { templates: updatedTemplates };
    });
  };

  addTemplateRow = (section) => {
    this.setState((prevState) => {
      const updatedTemplates = [
        ...prevState.templates,
        {
          name: '',
          section: section,
          source: '',
          category: [],
          amount: '',
          currency: ''
        },
      ];
      return { templates: updatedTemplates };
    });
  };

  handleOpen = (open) => {
    this.setState({ open: open });
  };

  handleSave = () => {
    this.props.handleSave(this.state.templates);
  };

  isSaveDisabled = () => {
    const { templates } = this.state;

    // 1. Check for basic required fields
    const hasIncompleteFields = templates.some((template) => {
      if (!template.name) return true;
      if (template.source === 'Sum of Above' && (!template.category || template.category.length < 2)) return true;
      if (!template.source && !template.amount) return true;
      if (template.source && (!template.category || template.category.length === 0)) return true;
      return false;
    });

    if (hasIncompleteFields) return true;

    // 2. Check for Duplicate Names across ALL sections
    const names = templates.map(t => t.name.trim()).filter(Boolean);
    const hasDuplicates = new Set(names).size !== names.length;

    return hasDuplicates;
  };

  render() {
    const { templates } = this.state;
    const { allLedgers, marketplaceCategory } = this.props;

    const renderSection = (sectionName) => (
      <>
        <h4 style={{ marginLeft: '24px', marginTop: '24px' }}>{sectionName}</h4>
        <div
          style={{
            display: 'flex',
            justifyContent: 'left',
            marginTop: '16px',
            marginLeft: '24px',
            marginRight: '24px',
          }}
        >
          <div className="transaction-form-section">
            {templates
              .filter((template) => template.section === sectionName)
              .map((template, index) => (
                <SettingRow
                  key={index}
                  templates={templates}
                  index={index}
                  template={template}
                  allLedgers={allLedgers}
                  handleTemplateChange={this.handleTemplateChange}
                  removeTemplateRow={this.removeTemplateRow}
                  draggedIndex={this.state.draggedIndex}
                  onDragStart={this.onDragStart}
                  onDragOver={this.onDragOver}
                  onDragEnd={this.onDragEnd}
                  anchorEl={this.state.anchorEl}
                  marketplaceCategory={marketplaceCategory}
                  sectionName={sectionName}
                />
              ))}
            <div style={{ marginTop: '30px' }}>
              <IconButton onClick={() => this.addTemplateRow(sectionName)}>
                <AddCircleIcon fontSize="small" color="secondary" />
              </IconButton>
            </div>
          </div>
        </div>
        <Divider style={{ marginLeft: '16px', marginRight: '16px', width: '98%' }} />
      </>
    );

    return (
      <React.Fragment>
        <TopToolbar
          pageName={`Income Statement Settings (${this.props.selectedYear} - ${this.props.selectedCurrency})`}
          menuItems={[
            {
              title: BACK,
              icon: <KeyboardBackspaceIcon />,
              onClick: () => {
                this.props.setCurrentPage(INCOME_STATEMENT_PAGES.TABLE, {});
              },
            },
            {
              title: 'Save',
              icon: <SaveIcon />,
              onClick: this.handleSave,
              disabled: this.isSaveDisabled(),
            },
          ].filter(Boolean)}
        />

        {renderSection('Operating Income')}
        {renderSection('Cost of Sales')}
        {renderSection('Operating Expenses')}
        {renderSection('Other Income')}
        {renderSection('Taxes')}

      </React.Fragment>
    );
  }
}

const SettingRow = React.memo(
  ({
    index,
    templates,
    template,
    allLedgers,
    handleTemplateChange,
    removeTemplateRow,
     draggedIndex, onDragStart, onDragOver, onDragEnd,marketplaceCategory, sectionName
  }) => {


    const isDuplicateName = templates.some(
      (t, i) => t.name.trim() === template.name.trim() &&
      // Find the current template's unique position to ensure we don't compare against itself
      // You might need to pass a unique ID if available, otherwise check index/section
      !(t.section === sectionName && i === templates.findIndex(temp => temp === template))
    );

    const isSumOfAboveRow = template.source === 'Sum of Above';

    // 2. Check if this row's name is being used by any "Sum of Above" row in the same section
    const isUsedInSum = templates.some(t =>
      t.section === sectionName &&
      t.source === 'Sum of Above' &&
      Array.isArray(t.category) &&
      t.category.includes(template.name)
    );

    // Row is draggable ONLY if it's not the Sum row AND it's not being used as a source
    const isDraggable = !isSumOfAboveRow && !isUsedInSum;

    const formatBalance = (balance) => {
      const validBalance = parseFloat(balance);
      if (isNaN(validBalance)) {
        return '0.00';
      }
      return validBalance
        .toFixed(2)
        .toString()
        .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }

    const onBlurHandle = (name, value) => {
      const formattedValue= formatBalance(value);
      handleTemplateChange({ target: { name: "amount", value: formattedValue } }, index,sectionName)
    };

    const displayNameEditingTextField = () => {
      return <TextField
        style={{marginLeft:"-8px",padding:"0"}}
        className="full-width-source-statement"
        variant="outlined"
        name="name"
        label="Name"
        InputLabelProps={{ shrink: true }}
        value={template.name || ""}
        onChange={(e) => handleTemplateChange({ target: { name: "name", value: e.target.value } }, index,sectionName)}
        required
        error={!template.name || isDuplicateName}
        helperText={isDuplicateName ? "Name already in use" : ""}
      />
    }

    const displaySourceEditingDropdown = () => {

      if(template.section){
        return (
          <Autocomplete
            className="full-width-source-statement"
            options={INCOME_SOURCE_OPTIONS}
            getOptionLabel={(option) => option}
            value={template.source || null}
            onChange={(e, value) => handleTemplateChange({
              target: { name: "source", value: value } }, index,sectionName)
            }
            renderInput={(params) =>
              <TextField
                {...params}
                name="source"
                label="Source"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
              />
            }
          />
        );
      }else{
        return null
      }

    }

    const displayCategoryEditingDropdown = () => {
      if (template.section) {
        if (template.source === 'Ledgers') {
          return (
            <div>
              <Autocomplete
                className="full-width-ledger-category"
                multiple
                value={
                  Array.isArray(template.category)
                    ? template.category
                        .map((cat) =>
                          allLedgers.find((ledger) => ledger.name === cat)
                        )
                        .filter(Boolean)
                    : []
                }
                options={(allLedgers || []).sort(
                  (a, b) => a.displayOrder - b.displayOrder
                )}
                getOptionLabel={(option) => option.name || ''}
                autoHighlight={true}
                renderTags={(value) => {
                  return value.map((option) => (
                    <Chip
                      key={option.name}
                      variant="outlined"
                      size="small"
                      style={{
                        borderColor: '#acd685',
                        margin: '1px 6px 1px 0',
                        fontSize: '12px',
                      }}
                      label={option.name}
                    />
                  ));
                }}
                renderOption={(option, { selected }) => (
                  <React.Fragment>
                    <Checkbox
                      icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                      checkedIcon={<CheckBoxIcon fontSize="small" />}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.name}
                  </React.Fragment>
                )}
                name="category"
                onChange={(e, value) =>
                  handleTemplateChange(
                    {
                      target: {
                        name: 'category',
                        value: value.map((cat) => cat?.name),
                      },
                    },
                    index,
                    sectionName
                  )
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Ledgers"
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    name="category"
                    required
                    error={!template.category}
                  />
                )}
              />
            </div>
          );
        } else if (template.source === 'Marketplace Summary') {
          return (
            <div>
              <Autocomplete
                className="full-width-ledger-category"
                multiple
                value={
                  Array.isArray(template.category)
                    ? template.category
                        .map((cat) =>
                          marketplaceCategory.find(
                            (marketplace) => marketplace === cat
                          )
                        )
                        .filter(Boolean)
                    : []
                }
                options={(marketplaceCategory || []).sort(
                  (a, b) => a.displayOrder - b.displayOrder
                )}
                getOptionLabel={(option) => option || ''}
                autoHighlight={true}
                renderTags={(value) =>
                  value.map((option) => (
                    <Chip
                      key={option}
                      variant="outlined"
                      size="small"
                      style={{
                        borderColor: '#acd685',
                        margin: '1px 6px 1px 0',
                        fontSize: '12px',
                      }}
                      label={option}
                    />
                  ))
                }
                renderOption={(option, { selected }) => (
                  <React.Fragment>
                    <Checkbox
                      icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                      checkedIcon={<CheckBoxIcon fontSize="small" />}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option}
                  </React.Fragment>
                )}
                name="category"
                onChange={(e, value) =>
                  handleTemplateChange(
                    {
                      target: {
                        name: 'category',
                        value: value.map((cat) => cat),
                      },
                    },
                    index,
                    sectionName
                  )
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Marketplace Summary"
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    name="category"
                    required
                    error={!template.category}
                  />
                )}
              />
            </div>
          );
        } else if (template.source === 'Cost of Sales') {
          return (
            <div>
              <Autocomplete
                className="full-width-ledger-category"
                multiple
                value={
                  Array.isArray(template.category)
                    ? template.category
                        .map((cat) =>
                          COST_OF_SALES_OPTIONS.find((sales) => sales === cat)
                        )
                        .filter(Boolean) // Ensure no undefined values
                    : [] // Fallback to an empty array if marketplaceCategory is not an array
                }
                options={(COST_OF_SALES_OPTIONS || []).sort(
                  (a, b) => a.displayOrder - b.displayOrder
                )}
                getOptionLabel={(option) => option || ''}
                autoHighlight={true}
                renderTags={(value) =>
                  value.map((option) => (
                    <Chip
                      key={option}
                      variant="outlined"
                      size="small"
                      style={{
                        borderColor: '#acd685',
                        margin: '1px 6px 1px 0',
                        fontSize: '12px',
                      }}
                      label={option}
                    />
                  ))
                }
                renderOption={(option, { selected }) => (
                  <React.Fragment>
                    <Checkbox
                      icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                      checkedIcon={<CheckBoxIcon fontSize="small" />}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option}
                  </React.Fragment>
                )}
                name="category"
                onChange={(e, value) =>
                  handleTemplateChange(
                    {
                      target: {
                        name: 'category',
                        value: value.map((cat) => cat),
                      },
                    },
                    index,
                    sectionName
                  )
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Cost of Sales"
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    name="category"
                    required
                    error={!template.category}
                  />
                )}
              />
            </div>
          );
        } else if (template.source === 'Sum of Above') {
          // Get all OTHER names in the same section
          const availableOptions = templates
            .filter(
              (t) =>
                t.section === sectionName && t.name !== template.name && t.name
            )
            .map((t) => t.name);

          return (
            <div>
              <Autocomplete
                className="full-width-ledger-category"
                multiple
                value={
                  Array.isArray(template.category) ? template.category : []
                }
                options={availableOptions}
                getOptionLabel={(option) => option || ''}
                autoHighlight={true}
                renderTags={(value) =>
                  value.map((option) => (
                    <Chip
                      key={option}
                      variant="outlined"
                      size="small"
                      style={{
                        borderColor: '#acd685',
                        margin: '1px 6px 1px 0',
                        fontSize: '12px',
                      }}
                      label={option}
                    />
                  ))
                }
                renderOption={(option, { selected }) => (
                  <React.Fragment>
                    <Checkbox
                      icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                      checkedIcon={<CheckBoxIcon fontSize="small" />}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option}
                  </React.Fragment>
                )}
                name="category"
                onChange={(e, value) =>
                  handleTemplateChange(
                    {
                      target: { name: 'category', value: value },
                    },
                    index,
                    sectionName
                  )
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Names"
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    name="category"
                    required
                    // Validation: Error if less than 2 selections
                    error={!template.category || template.category.length < 2}
                    helperText={
                      !template.category || template.category.length < 2
                        ? 'Select at least 2 names'
                        : ''
                    }
                  />
                )}
              />
            </div>
          );
        }
      } else {
        return null;
      }
    };

    const displayBalanceEditingTextField = () => {
      if (!template.source) {
        // Currency is now set at the page level (the whole set is one currency), so the
        // manual row only needs an amount — entered in the set's currency.
        return (
          <div className="full-width-ledger-category">
            <div style={{ width: '150px' }}>
              <TextField
                required
                variant="outlined"
                name="amount"
                label="Amount"
                value={template.amount || ''}
                InputLabelProps={{ shrink: true }}
                onBlur={(e) => onBlurHandle(e.target.name, e.target.value)}
                onChange={(e) =>
                  handleTemplateChange(
                    {
                      target: {
                        name: 'amount',
                        value: e.target.value,
                      },
                    },
                    index,
                    sectionName
                  )
                }
              />
            </div>
          </div>
        );
      }
      return null;
    };


    return (
      <div className="transaction-form-details"
            draggable={isDraggable}
            onDragStart={() => isDraggable && onDragStart(index, sectionName)}
            onDragOver={(e) => {
              e.preventDefault();
              onDragOver(index, sectionName);
            }}
            // onDragOver={(e) => {
            //   e.preventDefault();
            //   if (isDraggable) onDragOver(index, sectionName);
            // }}
            onDragEnd={() => isDraggable && onDragEnd(sectionName)}
      >

        <div style={{ width: '4.5%', height: '60px', display: 'flex' }}>
          <IconButton onClick={() => removeTemplateRow(index,sectionName)}>
            <RemoveCircleIcon fontSize="small" color="error" />
          </IconButton>
        </div>

        <div className="rowSpecLedger full-width-name">

          {displayNameEditingTextField()}
          {displaySourceEditingDropdown()}
          {displayCategoryEditingDropdown()}
          {displayBalanceEditingTextField()}
          {isDraggable && (
          <MenuIcon
            style={{
              marginTop: '-10px',
              cursor: 'grab',
              opacity: '0.6',
              alignSelf: 'center',
            }}
          />
          )}
        </div>
      </div>
    );
  }
  )
;


export default IncomeStatementSettings;

